module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "header-wrapper"
  }, [_c('router-link', {
    attrs: {
      "to": "/home"
    }
  }), _vm._v(" "), _c('router-link', {
    staticClass: "head-user",
    attrs: {
      "to": "/main"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "product-banner"
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "register-btn"
  }), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "contact-us"
  }, [_c('div', {
    staticClass: "contact_top"
  }, [_c('div', {
    staticClass: "nav-links"
  }, [_c('ul', [_c('li', [_c('router-link', {
    attrs: {
      "to": "/about"
    }
  }, [_vm._v("关于我们")])], 1), _vm._v(" "), _c('li', [_vm._v("|")]), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/contact"
    }
  }, [_vm._v("联系我们")])], 1), _vm._v(" "), _c('li', [_vm._v("|")]), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/pay"
    }
  }, [_vm._v("支付方式")])], 1), _vm._v(" "), _c('li', [_vm._v("|")]), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/agreement"
    }
  }, [_vm._v("服务条款")])], 1)])])]), _vm._v(" "), _vm._m(2)]), _vm._v(" "), _c('c-footer', {
    attrs: {
      "status": "home"
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "product_title"
  }, [_c('h4', [_vm._v("阿贝云简介")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "background-color": "#f7f7f7",
      "padding": "0 0.2rem 1rem 0.2rem",
      "margin-top": "0.3rem"
    }
  }, [_c('div', {
    staticClass: "agreement-content"
  }, [_c('p', {
    staticClass: "ab-introduce-p"
  }, [_vm._v("阿贝云是陕西云游四海网络科技有限公司旗下网络服务品牌，十年云计算战队于2018年10月1日创建。公司致力于为大众提供最优质的互联网基础服务和物联网服务，包括：域名注册、虚拟主机、云服务器、主机托管租用、CDN网站加速、物联网应用等服务。以帮助客户轻松、 高速、高效的应用互联网/物联网，提高企业竞争能力。")]), _vm._v(" "), _c('p', {
    staticClass: "ab-introduce-p"
  }, [_vm._v("阿贝云一直秉承\"以人为本、客户为尊、永续创新\"的价值观，坚持\"以微笑收获友善， 以尊重收获理解，以责任收获支持，以谦卑收获成长\"的行为观向客户提供全面优质的互联网应用服务。阿贝云建立在已为数以百万计的网民提供优质的免费服务的行业经验上继续不忘初衷、秉承承诺，并且让服务质量持续提升。")]), _vm._v(" "), _c('p', {
    staticClass: "ab-introduce-p"
  }, [_vm._v("阿贝云凭借雄厚的研发实力和坚实的行业经验积累，自主研发了数据中心云计算综合管理平台。其中包括“虚拟主机管理系统、云服务器管理系统、域名动态解析系统、CDN分布式转发系统、光纤架构分布式存储系统、工信部备案管理系统、黑洞封堵清洗系统等”。")]), _vm._v(" "), _c('p', {
    staticClass: "ab-introduce-p"
  }, [_vm._v("展望未来，我们继续疯狂而且满怀信心，我们的点滴进步均来源于广大客户的不断支持，阿贝人必将以更饱满的热情和更优质的产品与服务回报广大客户。")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "line-height": "1rem",
      "color": "#f38c7b",
      "font-size": "0.48rem"
    }
  }, [_vm._v("行业领军人物发源地")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "line-height": "1rem",
      "color": "#f38c7b",
      "font-size": "0.18rem"
    }
  }, [_vm._v("十八年来无数新手从这里起步，成为如今的行业领军人物")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "contact_bottom clearfix"
  }, [_c('a', {
    staticClass: "logo-bottom",
    attrs: {
      "href": "javascript:void(0)"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "weixin-b"
  }, [_c('div', {
    staticClass: "clearfix"
  }, [_c('a', {
    staticStyle: {
      "float": "right",
      "margin-right": "0.32rem"
    },
    attrs: {
      "href": "https://www.abeiyun.com"
    }
  }, [_vm._v("切换电脑版")])]), _vm._v(" "), _c('div', {
    staticClass: "contact_bottom_r"
  }, [_vm._v("\n          ©2018 abeiyun All rights reserved\n        ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b0fda046","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/user/about.vue
// module id = iv6M
// module chunks = 1